/**
 * Messaging — server-driven alerts/banners/badges types.
 * Mirrors the contract emitted by hephaestus-messaging-api (T7 spec §3, §5).
 */

import type { PhemeMessage } from '@francisquiniai/cuidari-core/messaging'

export type {
  DismissResponse,
  MessagesResponse,
  PlacementSlot,
} from '@francisquiniai/cuidari-core/messaging'

export type ServerMessage = PhemeMessage

export class MessagingApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public body: unknown,
  ) {
    super(message)
    this.name = 'MessagingApiError'
  }
}
